import { render, staticRenderFns } from "./PersonalAwayEntitlementTable.vue?vue&type=template&id=660947a5&scoped=true&"
import script from "./PersonalAwayEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./PersonalAwayEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660947a5",
  null
  
)

export default component.exports